<template>
  <div id="calculateurSunethic">
    <ModalMail
      v-show="showModal"
      @close="closeModal"
    >
  </ModalMail>
  <div class="reassurance">
    <div class="reassurance_content">
      <div class="reassurance_name">Bonjour et bienvenue sur le simulateur Sunethic,</div>
      <p class="reassurance_info">
        Grâce à seulement 4 données à renseigner dans notre simulateur, vous allez avoir très rapidement et facilement les réponses à ces questions  :
          <ul>
            <li> De combien de panneaux ai-je besoin par rapport à ma facture mensuelle ?</li>

            <li> Quel est le budget moyen correct pour cette recommandation ?</li>

              <li> Combien pourrais-je économiser par an et pendant 25 ans ?</li>

            <li>  Quelle serait la rentabilité ? En combien de temps vais-je amortir cet investissement ?</li>
          </ul>
          En deuxième étape, recevez par mail votre estimation encore plus détaillée.
      </p>
    </div>
  </div>

  <div class="entryPointSunEthic" v-show="!estimationDone && !showConfigurateur">
    <div class="sectionContainer">
      <span class="h2like sectionTitle">Localisation</span>
      <div id="locationContainer">

        <div id="mapContainer">
          <l-map :center="center" :zoom="zoom" ref="map" maxZoom="18" minZoom="0" @click="updateMarkerPosition">
            <l-tile-layer :url="url"></l-tile-layer>
            <l-marker :lat-lng="center" draggable="true"></l-marker>
          </l-map>
        </div>
        <div class="locationInputDiv" style="flex:1;display: flex;flex-direction: column;margin-left:20px;margin-right:20px;justify-content: center;  box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.07);-webkit-box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.07);-moz-box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.07);padding-left:40px;padding-right:40px;text-align:center;">
          <div style="display: block;width: 100%;">
            <span style="font-size:18px;text-align:left;margin-bottom:30px;display:block">Renseignez votre ville ou votre code postal pour estimer votre production </span>
            <input style="display:block;" type="text" name="" v-model="addressCustomer" v-on:keyup.enter="lookForCoords">
            <button id="validCoords" class="btn btn-simulateur" style="  border-radius: 30px !important;" type="button" @click="lookForCoords" :disabled="!addressCustomer" name="button">Valider</button>
          </div>
        </div>
      </div>
    </div>


    <div class="sectionContainer" id="orientationZone" >
      <h2 class="sectionTitle">Orientation des panneaux solaires</h2>
      <div class="" style="display: flex; align-content: center; align-items: center;width:100%;padding-bottom: 50px;">
        <div class="sunPositionSideIndicator" style="flex:1;text-align:center;">

          <img src="/wp-content/uploads/2022/11/ouest.svg" alt="" style="width:100px;">
        </div>
        <div class="circle-container">
          <span v-for="(az, index) in azimuth_values" :key="index">
            <input :id="az.name" type="radio" v-model="azimuth" :value="az" />
            <label :class="az.cssClass" :for="az.name">
              <div  :class="az.cssClass">
                <span>{{az.name}}</span>
              </div>
            </label>
          </span>
        </div>
        <div class="sunPositionSideIndicator" style="flex:1;text-align:center">
          <img src="/wp-content/uploads/2022/11/est.svg" alt="" style="width:100px;">
        </div>
      </div>
      <div class="onlyMobile">
          Orientation choisi : {{azimuth.name}}
      </div>
    </div>





    <div class="sectionContainer">
      <h2 class="sectionTitle">Inclinaison des panneaux solaires</h2>
      <div class="inclinaison_wrapper">
        <p class="form__answer" v-for="(incl,index) in this.inclinations_available" :key="index">
          <input type="radio" name="match" :id="incl.id" :value="incl" v-model="inclination">
          <label :for="incl.id">
            <svg v-bind:style="{transform: 'rotate('+ incl.cssangle + 'deg)' }" width="86px" height="86px" viewBox="0 0 110 8">
              <image id="Objet_dynamique_vectoriel" data-name="Objet dynamique vectoriel" width="110" height="8" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAAAICAYAAAAY9sq8AAAAfElEQVRIie3WsQ3CMBCG0ecIBnIDElCEnRiDmUIRBCJNBgIRdBJDxLLfCP9X3CVYZgdcsUenWaMvXrik7JGW2Q53bFuuIrxxjHADzrWvUZhbhIuCm9qXKMyn3bNCRbix9hEKNLbnpDxx2k5dyib0eP5fzmadok006lM2/QCBPxzw7XdAPAAAAABJRU5ErkJggg==" />
            </svg>
            <span style="display:block" class="text_black">{{incl.label}}</span>
            <span style="display:block;" class="text_green">{{incl.description}}</span>
          </label>
          <span v-if="incl.id== 'standard'" style="display:block;margin-top: 10px;font-size: 12px;">Inclinaison recommandée<br/>Inclinaison des stations</span>
        </p>
      </div>
    </div>









    <div class="sectionContainer">
      <span class="h2like sectionTitle">Montant mensuel de facture</span>
      <div class="wrapper-range">
        <div class="field">
          <div class="sliderValue">
            <span>{{monthlyBill}}€</span>
          </div>
          <div class="value left">20€</div>
          <input type="range" min="20" max="350" v-model='monthlyBill' step="5">
          <div class="value right">350€</div>
        </div>
      </div>
    </div>


    <button id="doEstimation" class="btn btn-simulateur" style="  border-radius: 30px !important;"  type="button" @click="calculateEstimateProduction" name="button">Lancer l'estimation</button>
    <div class="" id="errorEstimation" v-if="errorEstimation != ''">
      {{errorEstimation}}
    </div>
  </div>



  <div class="calculatedValues" v-show="estimationDone">
    <div class="recommandations">
      <div class="leftContainer">
        <h2>NOTRE RECOMMANDATION</h2>
        <p class="text-justify recoDesc">
          Une station de {{this.pvSize}} panneau<span v-if="pvSize > 1">x</span> solaire<span v-if="pvSize > 1">s</span>, soit une puissance recommandée de {{ (pvPower * 1000).toFixed() }} Wc<br/>
          Vous pouvez modifier notre recommandation pour comparer.
        </p>
      </div>
      <div class="rightContainer">
        <div class="panelsHeader">
          <span class="pvSize">
            <div class="panneauxIcons">
              <svg v-for="index in pvSize" :key="index" id="panneau" version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 267.8 415" style="enable-background:new 0 0 267.8 415;" xml:space="preserve">
              <g>
                <defs>
                  <path id="SVGID_1_P" d="M10.3,336l30.2-101.7L90,252.9L57.7,361.7L10.3,336z M103.6,246.2l32.8-110.3l51.6,11.5l-34.9,117.4
                    L103.6,246.2z M43.6,223.7L73.9,122l51.6,11.5L93.2,242.3L43.6,223.7z M145.4,329.5L237,21.3l18.4,5.5l-51.5,173.4l-60.2,202.5
                    l-18.4-5.5l10.8-36.3c0.9-2.9-0.8-6-3.7-6.9c-2.9-0.9-6,0.8-6.9,3.7l-10.4,35.1l-47.4-25.7l32.8-110.2l49.5,18.6l-15.1,51
                    c-0.9,2.9,0.8,6,3.7,6.9c0.5,0.2,1.1,0.2,1.6,0.2C142.5,333.5,144.7,332,145.4,329.5 M139.5,125.2L172.3,15l53.7,4.4l-34.9,117.3
                    L139.5,125.2z M77,111.3L107.2,9.7L161,14l-32.3,108.8L77,111.3z M107,0c-4.8,0-9.2,3.1-10.7,7.8c-0.2,0.6-0.3,1-0.3,1L66.2,108.9
                    L63,119.5L33.2,219.8l-3.2,10.6L0.3,330.6c0,0-0.3,1.3-0.3,3.2v0.1c0,3.2,1,8,5.9,10.6l109.9,61.2c0.2,0.1,0.4,0.2,0.5,0.3
                    l0.2,0.1c0.1,0,0.2,0.1,0.4,0.1l29,8.6c2.9,0.9,6-0.8,6.9-3.7l51.5-173.4l3.2-10.6l5.5-18.4L216,198l51.5-173.4
                    c0.9-2.9-0.8-6-3.7-6.9L234.5,9c0,0-0.1,0-0.1,0c-0.2,0-0.4-0.1-0.6-0.1l-0.1,0L107.9,0C107.6,0,107.4,0,107,0L107,0z"/>
                </defs>
                <clipPath id="SVGID_2_P">
                  <use xlink:href="#SVGID_1_P"  style="overflow:visible;"/>
                </clipPath>

                  <linearGradient id="SVGID_3_P" gradientUnits="userSpaceOnUse" x1="0" y1="415.0208" x2="1" y2="415.0208" gradientTransform="matrix(121.5935 508.3125 508.3125 -121.5935 -210884.5781 50426.8594)">
                  <stop  offset="0" style="stop-color:#FFCF00"/>
                  <stop  offset="9.003207e-02" style="stop-color:#F2CB07"/>
                  <stop  offset="0.2575" style="stop-color:#CFC218"/>
                  <stop  offset="0.484" style="stop-color:#97B235"/>
                  <stop  offset="0.7576" style="stop-color:#4A9D5C"/>
                  <stop  offset="1" style="stop-color:#008982"/>
                </linearGradient>
                <polygon class="st0_P" points="253.9,-60.7 362.5,393.2 14.5,476.4 -94.1,22.5 	"/>
              </g>
              </svg>

            </div>
            <span class="panels-heading">{{pvSize}} panneau<span v-if="pvSize > 1">x</span> solaire<span v-if="pvSize > 1">s</span> de 500 Wc</span>
            <!-- <input style="width:85px;font-size:18px;font-weight:500;" type="number" :step="(pvSize > 8)? 2 : 1" min="1" v-model="pvSize" @change="megaCalculateur"> -->
            <vue-number-input  @update:model-value="megaCalculateur" v-model="pvSize" :min="1" :max="18" :step="(pvSize >= 8)? 2 : 1" :inputtable="false" :center="true" inline controls ></vue-number-input>

          </span>

        </div>

      </div>
      <div style="display: block;width: 100%;text-align: left;">
        <a href="/stations#commander" target="_blank" class="btn btn-simulateur" style="margin-left:10px;margin-right:10px;" type="button" name="button">Commandez la station sunethic F</a>
        <a href="/kit-solaire-autoconsommation-francais-plug-and-play#commander" target="_blank" class="btn btn-simulateur" style="margin-left:10px;margin-right:10px;" type="button" name="button">Commandez un kit sunethic T</a>

        <button class="btn btn-simulateur" type="button" @click="showModal = true"  style="margin-left:10px;margin-right:10px;" name="button">Recevoir mon étude par mail</button>
        <a class="btn btn-simulateur" href="https://calendly.com/thomas-sunethic/30min"  style="margin-left:10px;margin-right:10px;" target="_blank" id="callCalendly">Echangez avec un conseiller</a>

      </div>

    </div>
    <div class="resultDataContainer">
      <div class="resultRappelDatas">
        <h3>RAPPEL DE VOS DONNÉES</h3>
        <div class="dataInner oneLine">
          <div class="dataItem">
            Facture mensuelle<br/>
            <strong>{{monthlyBill}} €</strong>
          </div>
          <div class="dataItem">
            Inclinaison des panneaux solaires<br/>
            <strong>{{inclination.label}} ({{inclination.description}}) </strong>
          </div>
          <div class="dataItem">
            Orientation<br/>
            <strong>{{azimuth.name}} </strong>
          </div>
          <div class="dataItem">
            Localisation<br/>
            <strong>{{ addressCustomerDisplay}}</strong>
          </div>
        </div>
        <button class="btn btn-simulateur" style="margin-right: auto;margin-left:auto;display: block;  border-radius: 30px !important;"  id="redo" type="button" name="button" @click="estimationDone = false">Recommencer mon estimation</button>

      </div>
      <div class="resultProductDatas">
        <h3>VOTRE PRODUCTION
          <div class="tooltip">
            <i class="fa fa-question"></i>
            <span class="tooltiptext">Les calculs de production par an sont des estimations non contractuelles </span>
          </div>
        </h3>
        <div class="dataInner">
          <div class="dataItem">
            Puissance totale des panneaux
            <div class="tooltip" id="tooltip_pvpower">
              <i class="fa fa-question"></i>
              <span class="tooltiptext">Puissance recommandée par sunethic en fonction de votre consommation kWh estimée </span>
            </div>
            <br/>
            <strong>{{ (pvPower * 1000).toFixed() }} Wc</strong>
          </div>
          <div class="dataItem">
            Production annuelle des panneaux
            <div class="tooltip" id="tooltip_pvproduction">
              <i class="fa fa-question"></i>
              <span class="tooltiptext">Tient compte de vos données renseignées et des pertes diverses de production inhérentes (14%) </span>
            </div>
            <br/>
            <strong>{{ parseFloat(yearlyProduction.E_y).toFixed()}} kWh </strong>
          </div>
          <div class="dataItem">
            Consommation actuelle
            <div class="tooltip" id="tooltip_conso">
              <i class="fa fa-question"></i>
              <span class="tooltiptext">Calculée sur un prix kWh 2025 de base de 0,2016€ TTC - Calcul kWh avec abonnement déduit </span>
            </div>
            <br/>
            <strong>{{ yearlyConsumption.toFixed()}} Kwh </strong>
          </div>
          <div class="dataItem">
            Couverture de ma consommation
            <div class="tooltip" id="tooltip_couverture">
              <i class="fa fa-question"></i>
              <span class="tooltiptext">Estimation de votre taux d'autoproduction =  Production annuelle solaire kWh / Consommation actuelle kWh</span>
            </div>
            <br/>
            <strong>{{couverture.toFixed()}} % </strong>
          </div>
          <div class="dataItem  dataImportant">
            Montant moyen de notre recommandation de puissance
            <div class="tooltip" id="tooltip_budget">
              <i class="fa fa-question"></i>
              <span class="tooltiptext">Estimation sunethic selon les prix moyens du marché, tous intervenants confondus</span>
            </div>
            <br/>
            <strong>{{ budget}} €</strong>
          </div>
        </div>

      </div>
      <div class="resultEcoDatas">
        <h3>VOTRE RENTABILITÉ PAR AN ET SUR 25 ANS
          <div class="tooltip" id="tooltip_pvpower">
            <i class="fa fa-question"></i>
            <span class="tooltiptext">Les calculs d'économies et rentabilité à 25 ans sont des estimations non contractuelles.</span>
          </div>
          </h3>

        <div class="dataInner" >
          <div class="dataItem dataImportant">
            Amorti en seulement
            <div class="tooltip" id="tooltip_amortien">
              <i class="fa fa-question"></i>
              <span class="tooltiptext">Économies moyennes annuelles / Montant moyen à investir</span>
            </div>
            <br/>
            <strong>{{rentabilite_delai.avec_surplus.toFixed()}} ans</strong>
          </div>

          <div class="dataItem dataImportant">
            Rentabilité moyenne par an
            <div class="tooltip" id="tooltip_rentabiliteparan">
              <i class="fa fa-question"></i>
              <span class="tooltiptext">Rentabilité moyenne calculée sur une durée de 25 ans </span>
            </div>
            <br/>
            <strong>{{rentabilite_moyenne.avec_surplus.toFixed()}} %</strong>
          </div>

          <div class="dataItem dataImportant">
            Économies moyennes par an
            <div class="tooltip" id="tooltip_ecomoy">
              <i class="fa fa-question"></i>
              <span class="tooltiptext">Économies moyennes annuelles calculées sur une durée de 25 ans en tenant compte :<br/>
              - Dégradation production panneau par an : -0,5%. <br/>
              - Hausse prévisionnelle prix electricité 5% jusqu'en 2037 puis maintien<br/>
              - Avec valorisation du surplus
            </span>
            </div>
            <br/>
            <strong>{{eco_moyenne.avec_surplus.toFixed()}} €</strong>
          </div>

          <div class="dataItem dataImportant">
            Baisse moyenne de votre facture
            <div class="tooltip" id="tooltip_baisse">
              <i class="fa fa-question"></i>
              <span class="tooltiptext">Moyenne sur 25 ans </span>
            </div>
            <br/>
            <strong>{{reduction_moyenne.avec_surplus.toFixed()}} % </strong>
          </div>


          <div class="dataItem dataImportant">
            Baisse de votre facture 2025
            <br/>
            <strong>{{reductionFacture.avec_surplus[0].toFixed()}} % </strong>
          </div>

        </div>
        <div class="chartContainer" style="display:flex;flex-wrap:wrap;width:100%;margin-top:50px;">
          <apexchart  v-show="estimationDone" ref="realtimeChart" :options="options" :series="series"></apexchart>
          <apexchart  v-show="estimationDone" ref="chart25years" :options="options_2" :series="series_2"></apexchart>
        </div>
      </div>

        <div style="display: block;width: 100%;text-align: center;">
          <a href="/stations#commander" target="_blank" class="btn btn-simulateur" style="margin-left:auto;margin-right:auto;" type="button" name="button">Commandez la station sunethic F</a>
          <a href="/kit-solaire-autoconsommation-francais-plug-and-play#commander" target="_blank" class="btn btn-simulateur" style="margin-left:auto;margin-right:auto;" type="button" name="button">Commandez un kit sunethic T</a>

          <button class="btn btn-simulateur" type="button" @click="showModal = true"  name="button">Recevoir mon étude par mail</button>
          <a class="btn btn-simulateur" href="https://calendly.com/thomas-sunethic/30min" target="_blank" id="callCalendly">Echangez avec un conseiller</a>

        </div>
    </div>




    <div class="" id="etudeSend" v-if="etudeSend == true">
      Votre étude vient de vous être envoyée par mail.
    </div>
    <div class="" id="errorSendEtudeByMail" v-if="etudeSendError != ''">
      {{etudeSendError}}
    </div>
  </div>
</div>
  <div v-if="dataloading == true" class="loader" style="position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      background: #000000C0;
      z-index: 60000;
      color: #FFF;
      text-align: center;
      font-size: 24px;">
    <div style="text-align:center;display:block;margin:auto"> Votre estimation est en cours. <br /> Merci de patienter quelques instants. </div>
  </div>
  <div v-if="dataloadingEmail == true" class="loader" style="position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      background: #000000C0;
      z-index: 60000;
      color: #FFF;
      text-align: center;
      font-size: 24px;">
    <div style="text-align:center;display:block;margin:auto"> Votre étude est en cours d'envoi. <br /> Merci de patienter quelques instants. </div>
  </div>
</template>

<script>
import { LMap, LTileLayer,LMarker } from 'vue3-leaflet';
import L from 'leaflet';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import axios from 'axios';
//  import Toggle from '@vueform/toggle'
import ModalMail from "./Modal.vue";

export default {
  name: 'CalculateurSunethic',
  components: {
  LMap,
  LTileLayer,
  LMarker,
  VueNumberInput,
  ModalMail,
  },
  data () {
    return {
      etudeSendError: "",
      customerName: "",
      showModal: false,
      etudeSend: false,
      email:"",
      dataloading: false,
      errorEstimation: "",
      avecSurplus: false,
      showConfigurateur: false,
      azimuth_values: [
        {
          name:"SUD",
          value:"0",
          cssClass: "deg5"
        },
        {
          name:"SUD EST",
          value:"-45",
            cssClass: "deg4"
        },
        {
          name:"EST",
          value:"-90",
            cssClass: "deg3"
        },
        {
          name:"NORD EST",
          value:"-135",
            cssClass: "deg2"
        },
        {
          name:"NORD",
          value:"180",
          cssClass: "deg1"
        },
        {
          name:"NORD OUEST",
          value:"135",
            cssClass: "deg8"
        },
        {
          name:"OUEST",
          value:"90",
            cssClass: "deg7"
        },
        {
          name:"SUD OUEST",
          value:"45",
            cssClass: "deg6"
        }
      ],
      monthLabels: ["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],
      monthlyBill: 60,
      inclination:        {
                id: 'standard',
                label: "Standard",
                description: "25 à 34 °",
                value:30,
                cssangle:30,
              },
      inclinations_available:[
        {
          id: 'aplat',
          label: "À plat",
          description: "0 °",
          value:0,
          cssangle:0,
        },
        {
          id: 'faiblepente',
          label: "Faible",
          description: "5 à 14 °",
          value:10,
          cssangle:5,
        },
        {
          id: 'pentemoyenne',
          label: "Moyenne",
          description: "15 à 24 °",
          value:20,
          cssangle:20,
        },
        {
          id: 'standard',
          label: "Standard",
          description: "25 à 34 °",
          value:30,
          cssangle:30,
        },
        {
          id: 'penteforte',
          label: "Forte",
          description: "35 à 44 °",
          value:40,
          cssangle:60,
        },
        {
          id: 'facade',
          label: "Sur façade",
          description: "90 °",
          value:90,
          cssangle:90,
        },
      ],
      azimuth:  {
          name:"SUD",
          value:"0",
          cssClass: "deg5"
      },
      yearlyBill: 0,
      yearlyConsumption: 0,
      yearlyProduction: 0,
      autoconsomation_n1 : 0,
      revente_n1: 0,
      monthlyConsumption: new Array(12),
      estimationMonthly: new Array(12),
      autoconsoMonthly: new Array(12),
      surplusMonthly: new Array(12),
      pvSize : 0,
      pvPower: 0, //in kW
      location:{lat:43.91438711780441,lng:4.887738813335894},
      gettingLocation: false,
      addressCustomer: "",
      addressCustomerDisplay: "",
      estimationDone: false,
      errorMsg : null,
      //eco ones
      arrayLabelEco:[],
      haussePrix: [],
      avgElecPrice: [],
      factureSansPV: [],
      prixRevente: [],
      facteurDegradation: [],
      puissancePostDegradation: [],
      revente: [],
      autoconso: [],
      couverture: 0,
      solde: [],
      eco: [],
      eco_global: [],
      eco_revente: [],
      eco_total_cumul: [],
      tro : [],
      tro_sanssurplus: [],
      factureAvecPV: [],
      reductionFacture: {
          avec_surplus : [0],
          sans_surplus : [0]
      },
      reducMoyen: 0,
      ecoMoyen: 0,
      rentabilite_delai: {
          avec_surplus : -1,
          sans_surplus : -1
      },
      rentabilite_moyenne: {
          avec_surplus : -1,
          sans_surplus : -1
      },
      eco_moyenne: {
          avec_surplus : -1,
          sans_surplus : -1
      },
      reduction_moyenne: {
        avec_surplus : -1,
        sans_surplus : -1
      },
      newfacture: {
          avec_surplus : [],
          sans_surplus : []
      },
      //LEAFLET ONES
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:'&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 12,
      center: [ 43.91438711780441, 4.887738813335894 ],
      //APEX CHARTS ONES
      options: {
        chart: {
           height: 350,
           type: 'bar',
           toolbar: {
               show: false,
           },

         },
         tooltip: {
          y: {
            formatter: function(value) {
              return value.toFixed()+"€"
            }
          }
        },
        title : {
          text:"Facture annuelle 2025",
          align:'center',
          style:{
            fontSize:"25px",
          }
        },
        legend: {
               show: false
        },
         plotOptions: {
           bar: {
             borderRadius: 10,
             columnWidth: '75%',
             distributed: true,
           }
         },
         dataLabels: {
           enabled: true,
           formatter: function (val) {
             return val.toFixed()+" €"
           },
           style: {
             fontSize: '20px',
                fontWeight: "500",
                colors: ["#000"],
           }
         },
         stroke: {
           width: 2
         },
         colors:['#1A73E8','#f8d04d', '#408c85'],
         grid: {
           row: {
             colors: ['#fff', '#f2f2f2']
           }
         },
         xaxis: {
           categories: ['Sans solaire', 'Avec solaire', 'Économies' ],
           tickPlacement: 'on'
         },
         yaxis: {
           title: {
             text: 'Montant en euros',
           },
           labels: {
              formatter: function (value) {
                return value.toFixed() + "€";
              }
            },
         },
       },
      series: [{
           name: 'Montant en euros',
           data: [0,0,0],
           labels: ['Sans solaire', 'Avec solaire', 'Économies' ]
         }],

    series_2: [{
         name: 'Montant en euros',
         data: [0,0,0],
         labels: ['Sans solaire', 'Avec solaire', 'Économies' ]
       }],

    options_2: {
      chart: {
         height: 350,
         type: 'bar',
         toolbar: {
             show: false,
         },

       },
       tooltip: {
        y: {
          formatter: function(value) {
            return value.toFixed()+"€"
          }
        }
      },
      title : {
        text:"Facture sur 25 ans",
        align:'center',
        style:{
          fontSize:"25px",
        }
      },
      legend: {
             show: false
      },
       plotOptions: {
         bar: {
           borderRadius: 10,
           columnWidth: '75%',
           distributed: true,
         }
       },
       dataLabels: {
         enabled: true,
         formatter: function (val) {
           return val.toFixed()+" €"
         },
         style: {
           fontSize: '20px',
           fontWeight: "500",
           colors: ["#000"],
         }
       },
       stroke: {
         width: 2
       },
       colors:['#1A73E8','#f8d04d', '#408c85'],
       grid: {
         row: {
           colors: ['#fff', '#f2f2f2']
         }
       },
       xaxis: {
         categories: ['Sans solaire', 'Avec solaire', 'Économies' ],
         tickPlacement: 'on'
       },
       yaxis: {
         title: {
           text: 'Montant en euros',
         },
         labels: {
            formatter: function (value) {
              return value.toFixed() + "€";
            }
          },
       },
     },
   }
      },

  methods: {
    lookForCoords: async function(){
      axios
          .get('https://nominatim.openstreetmap.org/search?format=json&q='+encodeURI(this.addressCustomer)+'&countrycodes=fr&limit=1',
          {
            headers:{
                   'Content-Type': 'application/x-www-form-urlencoded',
                   'Accept': 'application/json'
                 }
           }).then(response => {
            if(response.data.length > 0){
              let calculatedPosition = response.data[0];
              this.center = L.latLng(calculatedPosition.lat, calculatedPosition.lon);
              this.location.lat = calculatedPosition.lat;
              this.location.lng = calculatedPosition.lon;
              this.zoom = 14;
            }
            else{
              alert("Impossible de trouver votre adresse !")
            }
          })
    },
    getPositionForDisplay: function(){
      axios.get("https://nominatim.openstreetmap.org/reverse?lat="+this.location.lat+"&lon="+this.location.lng+"&format=json").then(
        r => {
            console.log(r);
            if(r.data.address){
              if(r.data.address.village)
                  this.addressCustomerDisplay = r.data.address.postcode+" "+r.data.address.village;
              else if(r.data.address.town)
                this.addressCustomerDisplay = r.data.address.postcode+" "+r.data.address.town;
              else if(r.data.address.city)
                this.addressCustomerDisplay = r.data.address.postcode+" "+r.data.address.city;
              else
              this.addressCustomerDisplay = "";
            }
            else{
                this.addressCustomerDisplay = "";
            }
        })
    },
    updateMarkerPosition: function(e){
      this.center = e.latlng;
      this.location.lat = e.latlng.lat;
      this.location.lng = e.latlng.lng;
    },

    getAnnualBill: function(){
      this.yearlyBill = this.monthlyBill * 12;
    },
    getYearlyConsumption: function(){
      this.yearlyConsumption = (this.yearlyBill - 164) / 0.2016; //MAJ 2025
    },

    getMonthlyConsumptionEstimation: function(){
      this.monthlyConsumption[0] = this.yearlyConsumption * 0.12;
      this.monthlyConsumption[1] = this.yearlyConsumption * 0.14;
      this.monthlyConsumption[2] = this.yearlyConsumption * 0.12;
      this.monthlyConsumption[3] = this.yearlyConsumption * 0.08;
      this.monthlyConsumption[4] = this.yearlyConsumption * 0.07;
      this.monthlyConsumption[5] = this.yearlyConsumption * 0.06;
      this.monthlyConsumption[6] = this.yearlyConsumption * 0.05;
      this.monthlyConsumption[7] = this.yearlyConsumption * 0.05;
      this.monthlyConsumption[8] = this.yearlyConsumption * 0.05;
      this.monthlyConsumption[9] = this.yearlyConsumption * 0.06;
      this.monthlyConsumption[10] = this.yearlyConsumption * 0.09;
      this.monthlyConsumption[11] = this.yearlyConsumption * 0.11;

    },
    getPvSize: function(){
        this.pvSize = Math.round((this.yearlyConsumption * 0.65 ) / 570);
        if(this.pvSize > 8 && this.pvSize % 2 != 0)this.pvSize = this.pvSize + 1;
        this.pvSize = Math.min(this.pvSize,18);
    },



    getPvPower: function(){
      this.pvPower =  Math.floor(this.pvSize * 500) * 0.001;
      // var price = 800;
      // if(this.pvSize == 4) price = 750;
      // else if(this.pvSize == 5 || this.pvSize == 6) price = 730;
      // this.budget = this.pvSize * 800; //
      if(this.pvSize == 1)this.budget =700;
      else if(this.pvSize == 2)this.budget = 1200;
      else if(this.pvSize == 3)this.budget = 1700;
      else if(this.pvSize == 4)this.budget = 2200;
      else if(this.pvSize == 5)this.budget = 2700;
      else if(this.pvSize == 6)this.budget = 3400;
      else if(this.pvSize == 7)this.budget = 3800;
      else if(this.pvSize == 8)this.budget = 4300;
      else if(this.pvSize == 10)this.budget = 5400;
      else if(this.pvSize == 12)this.budget = 6300;
      else if(this.pvSize == 14)this.budget = 7200;
      else if(this.pvSize == 16)this.budget = 8100;
      else if(this.pvSize == 18)this.budget = 9000;
      else if(this.pvSize == 20)this.budget = 9500;
      else if(this.pvSize == 24)this.budget = 10950;
      else if(this.pvSize == 26)this.budget = 11500;

      // else if(this.pvSize == 20)this.budget = 14500;
      // else if(this.pvSize == 22)this.budget = 15500;
      // else if(this.pvSize == 24)this.budget = 16500;
      // else if(this.pvSize == 26)this.budget = 18000;
    },

    calculateClientInfo: function(){
      this.getAnnualBill();
      this.getYearlyConsumption();
      this.getMonthlyConsumptionEstimation();
      this.getPvSize();
      this.getPvPower();
      this.getPositionForDisplay();
    },

    calculateEstimateProduction: function(){
      this.errorMsg = "";
      this.dataloading = true;
      this.calculateClientInfo();
      this.calculateurProduction();

      // this.calculateurEco();

    },

    megaCalculateur: function(newPvSize,oldPvSize){
      console.log(newPvSize);
      if(newPvSize % 2 != 0 && newPvSize > 8){
        if(oldPvSize > newPvSize) this.pvSize = newPvSize - 1
        else this.pvSize = Math.min(newPvSize + 1,18)
      }
      else this.pvSize = Math.min(newPvSize,18);
        if(newPvSize == 8) this.pvSize = 8;
        if(newPvSize == 7) this.pvSize = 7;
        if(newPvSize == 6) this.pvSize = 6;
        console.log(this.pvSize);
      if(this.estimationDone== true){
        this.dataloading = true;
        this.getPvPower();
        this.calculateurProduction();
      }

    },
    // calculateurBudget: function(){
    //   var primeAutoConso = this.pvPower ;
    //   var budget_moyen = 0;
    //
    // },
    calculateurProduction: function(){
      this.errorEstimation = "";
      console.log("LAT",this.location.lat);
      console.log("lng",this.location.lng);
      console.log("pvPower",this.pvPower);
      console.log("angle",this.inclination.value);
      console.log("azimuth",this.azimuth.value);
      axios
          .get('/wp-json/calculateur/v1/estimation?lat='+this.location.lat+'&lon='+this.location.lng+'&peakpower='+this.pvPower+"&angle="+this.inclination.value+"&aspect="+this.azimuth.value,
    //    .get('http://127.0.0.1:8000?lat='+this.location.lat+'&lon='+this.location.lng+'&peakpower='+this.pvPower+"&angle="+this.inclination.value+"&aspect="+this.azimuth.value,
              {
                headers:{
                  'Content-Type': 'application/x-www-form-urlencoded',
                }
              }).then(response => {
                this.estimationDone = true;
                this.couverture = 0;
                this.autoconsomation_n1 = 0;
                this.revente_n1 = 0;
                this.estimationMonthly = response.data.monthly.fixed;
                this.yearlyProduction = response.data.totals.fixed;
                //var autoconso_total = 0;


                for (var i = 0; i < this.estimationMonthly.length; i++) {

                  // if(this.pvSize <= 2){
                  //
                  //   this.autoconsoMonthly[i] = this.estimationMonthly[i].E_m;
                  //   this.surplusMonthly[i] = 0;
                  // }
                  // else if(this.pvSize == 3){
                  //   this.autoconsoMonthly[i] = this.estimationMonthly[i].E_m * 0.8;
                  //   this.surplusMonthly[i] = this.estimationMonthly[i].E_m * 0.2;
                  // }
                  // else if(this.pvSize == 4){
                  //   this.autoconsoMonthly[i] = this.estimationMonthly[i].E_m * 0.8;
                  //   this.surplusMonthly[i] = this.estimationMonthly[i].E_m * 0.2;
                  // }
                  // else{
                  //   this.autoconsoMonthly[i] = this.estimationMonthly[i].E_m * 0.5;
                  //   this.surplusMonthly[i] = this.estimationMonthly[i].E_m * 0.5;
                  // }

                    // if(this.monthlyConsumption[i] - this.estimationMonthly[i].E_m < 50){
                    //   this.autoconsoMonthly[i] = this.estimationMonthly[i].E_m * 0.8;
                    //   this.surplusMonthly[i] = this.estimationMonthly[i].E_m * 0.5;
                    // }
                    // else{
                    //   this.autoconsoMonthly[i] = this.estimationMonthly[i].E_m * 0.5;
                    //   this.surplusMonthly[i] = this.estimationMonthly[i].E_m * 0.5;
                    // }

                    //MAJ 2025
                    this.autoconsoMonthly[i] = this.autoconsoCalculateur(this.estimationMonthly[i].E_m, this.monthlyConsumption[i]);
                    this.surplusMonthly[i] =  this.surplusCalculateur(this.estimationMonthly[i].E_m, this.monthlyConsumption[i]);
                    // FIN MAJ 2025
                  this.autoconsomation_n1 += this.autoconsoMonthly[i];
                  this.revente_n1 += this.surplusMonthly[i];
                  //autoconso_total += this.autoconsoMonthly[i];

                }
                var conso = (this.yearlyBill - 164) / 0.2016;

                console.log("conso : "+conso);

                this.couverture = (this.yearlyProduction.E_y / conso) * 100;
                console.log("couverture : "+this.couverture);
                this.calculateurEco();
          }).catch(err =>{
            console.log("74635 ",err);
            this.estimationDone = false;
            this.errorEstimation = "Erreur lors de votre estimation veuillez vérifier vos données et réessayer !";
            this.dataloading = false;
          } )
    },
    autoconsoCalculateur: function(prod,conso){
        if(prod - conso < 50)return prod * 0.8;
        else return prod * 0.5;
    },
    surplusCalculateur: function(prod,conso){
        if(prod - conso < 50)return prod * 0.2;
        else return prod * 0.5;
    },
    calculateurEco: function(){
      if(this.arrayLabelEco.length < 25){
        for (var i = 2025; i < 2050; i++) {
          this.arrayLabelEco.push(i);
          this.prixRevente.push(0.14); //MAJ 2025
        }
      }
      this.arrayLabelEco.forEach((item, i) => {
          if(i == 0){
              this.haussePrix[i] = 1;//2025
              this.facteurDegradation[i] = 100;
          }
          else{
            console.log(item);
            if(item == 2028){
              this.haussePrix[i] = 1.16;
            }
            else if(item == 2029){
              this.haussePrix[i] = 1.22;
            }
            else if(item == 2032){
              this.haussePrix[i] = 1.41;
            }
            else if(item == 2035){
              this.haussePrix[i] = 1.63;
            }
            else if(item <= 2036){
              this.haussePrix[i] = this.haussePrix[i - 1] * 1.05;//MAJ 2025
            }
            else{
              this.haussePrix[i] = this.haussePrix[i - 1];
            }

              this.facteurDegradation[i] = this.facteurDegradation[i - 1] - 0.5;
          }
          this.factureSansPV[i] = this.yearlyBill * this.haussePrix[i];

          this.avgElecPrice[i] = (0.2016 * this.haussePrix[i]);//MAJ 2025
          this.puissancePostDegradation[i] = this.pvPower  * (this.facteurDegradation[i] / 100);

          if(i == 0){
            this.autoconso[i] = this.autoconsomation_n1;
            this.revente[i] = this.revente_n1 ;
          }
          else{
            this.autoconso[i] = this.autoconso[i - 1] * 0.995;
            this.revente[i] =  this.revente[i - 1] * 0.995;
          }


          this.eco[i] = this.autoconso[i] * this.avgElecPrice[i];
          this.eco_revente[i] = this.revente[i] * this.prixRevente[i];
          this.eco_global[i] = this.eco[i] + this.eco_revente[i];

          if(i == 0) this.eco_total_cumul[i] = this.eco[i] + this.eco_revente[i];
          else this.eco_total_cumul[i] = this.eco_total_cumul[i-1] + this.eco[i] + this.eco_revente[i];

          this.solde[i] = this.eco_total_cumul[i] - this.budget;

          this.tro[i] = ( (this.eco[i] + this.eco_revente[i]) / this.budget) * 100;
          this.tro_sanssurplus[i] = (this.eco[i] / this.budget) * 100;

          this.newfacture.avec_surplus[i] = this.factureSansPV[i] - (this.eco[i] + this.eco_revente[i] );
          this.newfacture.sans_surplus[i] = this.factureSansPV[i] - this.eco[i];

          this.reductionFacture.avec_surplus[i] = (100 - (100 * ( (this.newfacture.avec_surplus[i] / this.factureSansPV[i]) ))) * -1;
          this.reductionFacture.sans_surplus[i] = (100 - (100 * ( (this.newfacture.sans_surplus[i] / this.factureSansPV[i]) ))) * -1;
      });



      this.rentabilite_moyenne.avec_surplus = ArrayAvg(this.tro);
      this.rentabilite_moyenne.sans_surplus = ArrayAvg(this.tro_sanssurplus);

      this.eco_moyenne.avec_surplus = ArrayAvg(this.eco_global);
      this.eco_moyenne.sans_surplus = ArrayAvg(this.eco);

      this.rentabilite_delai.avec_surplus = this.budget / this.eco_moyenne.avec_surplus;
      this.rentabilite_delai.sans_surplus = this.budget / this.eco_moyenne.sans_surplus;

      this.reduction_moyenne.avec_surplus = ArrayAvg(this.reductionFacture.avec_surplus);
      this.reduction_moyenne.sans_surplus = ArrayAvg(this.reductionFacture.sans_surplus);

      if(this.avecSurplus == true){
        this.series[0].data[0] = this.factureSansPV[0].toFixed(2);
        this.series[0].data[1] = this.newfacture.avec_surplus[0].toFixed(2);
        this.series[0].data[2] = this.eco_global[0].toFixed(2);
      //  this.$refs.realtimeChart.updateSeries([], false, true);
        this.series_2[0].data[0] = this.factureSansPV.reduce((partialSum, a) => partialSum + a, 0).toFixed(2);
        this.series_2[0].data[1] = this.newfacture.avec_surplus.reduce((partialSum, a) => partialSum + a, 0).toFixed(2);
        this.series_2[0].data[2] = this.eco_global.reduce((partialSum, a) => partialSum + a, 0).toFixed(2);
      //  this.$refs.chart25years.updateSeries([], false, true);
      }
      else{
        this.series[0].data[0] = this.factureSansPV[0].toFixed(2);
        this.series[0].data[1] = this.newfacture.sans_surplus[0].toFixed(2);
        this.series[0].data[2] = this.eco[0].toFixed(2);
    //    this.$refs.realtimeChart.updateSeries([], false, true);
        this.series_2[0].data[0] = this.factureSansPV.reduce((partialSum, a) => partialSum + a, 0).toFixed(2);
        this.series_2[0].data[1] = this.newfacture.sans_surplus.reduce((partialSum, a) => partialSum + a, 0).toFixed(2);
        this.series_2[0].data[2] = this.eco.reduce((partialSum, a) => partialSum + a, 0).toFixed(2);
    //    this.$refs.chart25years.updateSeries([], false, true);
      }
      this.dataloading = false;

      window.scrollTo(0,0);


   },
   updateGraphSeries: function(){
     if(this.avecSurplus == true){
       this.series[0].data[0] = this.factureSansPV[0].toFixed(2);
       this.series[0].data[1] = this.newfacture.avec_surplus[0].toFixed(2);
       this.series[0].data[2] = this.eco_global[0].toFixed(2);
       this.$refs.realtimeChart.updateSeries([], false, true);
       this.series_2[0].data[0] = this.factureSansPV.reduce((partialSum, a) => partialSum + a, 0).toFixed(2);
       this.series_2[0].data[1] = this.newfacture.avec_surplus.reduce((partialSum, a) => partialSum + a, 0).toFixed(2);
       this.series_2[0].data[2] = this.eco_global.reduce((partialSum, a) => partialSum + a, 0).toFixed(2);
       this.$refs.chart25years.updateSeries([], false, true);
     }
     else{
       this.series[0].data[0] = this.factureSansPV[0].toFixed(2);
       this.series[0].data[1] = this.newfacture.sans_surplus[0].toFixed(2);
       this.series[0].data[2] = this.eco[0].toFixed(2);
       this.$refs.realtimeChart.updateSeries([], false, true);
       this.series_2[0].data[0] = this.factureSansPV.reduce((partialSum, a) => partialSum + a, 0).toFixed(2);
       this.series_2[0].data[1] = this.newfacture.sans_surplus.reduce((partialSum, a) => partialSum + a, 0).toFixed(2);
       this.series_2[0].data[2] = this.eco.reduce((partialSum, a) => partialSum + a, 0).toFixed(2);
       this.$refs.chart25years.updateSeries([], false, true);
     }
   },
   closeModal: function(data){
     this.showModal = false;
     if(data) {
       this.email = data.email;
       this.customerName = data.name;
       this.getMyEstimationByMAil();
     }
   },
   getMyEstimationByMAil: function(){
     this.dataloadingEmail = true;
     axios.post("/wp-json/calculateur/v1/etude_save_pdf",JSON.stringify({
       userDatas : {
       email: this.email,
       name: this.customerName,
       yearlyBill: this.yearlyBill,
       monthlyConsumption: this.monthlyConsumption,
       yearlyConsumption: this.yearlyConsumption.toFixed(),
       address: this.addressCustomerDisplay,
       estimationMonthly: this.estimationMonthly,
       yearlyProduction: this.yearlyProduction.E_y.toFixed(),
       totalAutoConso: (this.yearlyProduction.E_y * 0.6).toFixed(),//MAJ 2025 Pour info TABLEAU CI-dessous : mettre pour tout 60% de la production en autoconsommation et 40% en surplus ( au lieu de 50 % 50%)
       totalSurplus:  (this.yearlyProduction.E_y * 0.4).toFixed(),//MAJ 2025 Pour info TABLEAU CI-dessous : mettre pour tout 60% de la production en autoconsommation et 40% en surplus ( au lieu de 50 % 50%)
       rentabilite_delai : this.rentabilite_delai.avec_surplus.toFixed(),
       economie_moyenne : this.eco_moyenne.avec_surplus.toFixed(),
       reduction_moyenne_facture : this.reduction_moyenne.avec_surplus.toFixed(),
       rentabilite_delai_wos : this.rentabilite_delai.sans_surplus.toFixed(),
       economie_moyenne_wos : this.eco_moyenne.sans_surplus.toFixed(),
       reduction_moyenne_facture_wos : this.reduction_moyenne.sans_surplus.toFixed(),
       facture_N : [this.factureSansPV[0].toFixed(), this.newfacture.avec_surplus[0].toFixed(),this.eco_global[0].toFixed()],
       facture_N25 : [this.series_2[0].data[0] , this.series_2[0].data[1], this.series_2[0].data[2] ],
       solde: this.solde,
       budget: this.budget,
       pvSize: this.pvSize,
       azimuth: this.azimuth.name,
       inclination: this.inclination.label
      }
  }),{
        headers: {
            'Content-Type': 'application/json',
        }
    } ).then( (r) =>{
        console.log(r);
        this.dataloadingEmail = false;
        this.etudeSendError = "";
        if(r.data == true)this.etudeSend = true;
        else this.etudeSendError = "Une erreur est survenue lors de l'envoi de votre étude. Veuillez réessayer";

     })
   },
  goToKit: function(){
    // let kit = (numIsPair(this.pvSize)) ? this.pvSize : this.pvSize + 1 ;
    // alert("Vous allez être redirigé vers le kit prêt à brancher "+kit+" panneaux");
      window.location.href = "/stations";
  },
  buyKit: function(){
    axios.get('/wp-json/calculateur/v1/secucheck').then( (r) => { console.log(r);
        axios.post("/wp-json/wc/store/cart/add-item",
        {
          id : 66,
          quantity: this.pvSize
        }, {
          headers:{
             'Nonce': r.data
          }
        }).then( (i) => {
          console.log(i);
            window.location.href = "/cart";
        }).catch( (e) => {
          console.log(e);
          alert("Erreur lors de l'ajout au panier !")
        });
    })
  },
},

  created() {
      if(!("geolocation" in navigator)) {
          this.gettingLocation = false;
          return;
      }
      navigator.geolocation.getCurrentPosition(pos => {
        this.gettingLocation = true;
        this.location.lat = pos.coords.latitude;
        this.location.lng = pos.coords.longitude;
        this.center = L.latLng(pos.coords.latitude,  pos.coords.longitude);
        this.zoom = 14;
      }, err => {
        this.gettingLocation = false;
        this.errorMsg = err.message;
      })
  },
  mounted() {
   this.$nextTick(() => {
      this.map = this.$refs.map;
   });
  },
  watch: {
      center(newCenter) {
        this.map.panTo(newCenter);
      },
      zoom(newZoom){
        this.map.setZoom(newZoom);
      },
      pvSizeEditor: {
         handler(val){
        this.pvSize = val;
        }
      }
  },

}




function ArrayAvg(myArray) {
    var i = 0, summ = 0, ArrayLen = myArray.length;
    while (i < ArrayLen) {
        summ = summ + myArray[i++];
    }
    return summ / ArrayLen;
}



</script>
<style media="screen">
#mapContainer{
  position: relative; width: calc(50% - 40px);margin-left:20px;margin-right: 20px;height: 300px; overflow: hidden;
}

.locationInputDiv{
  flex: 1 1 0%;
display: flex;
flex-direction: column;
margin-left: 20px;
margin-right: 20px;
justify-content: center;
box-shadow: rgba(0, 0, 0, 0.07) 0px 0px 7px 1px;
padding-left: 40px;
padding-right: 40px;
text-align: center;
}
#locationContainer{
  display:flex;
}

@media only screen and (max-width : 768px){
  #mapContainer{
    position: relative; width: calc(100% - 40px);margin: 20px;height: 300px; overflow: hidden;flex:auto;
  }
  #locationContainer{
    flex-direction: column-reverse;
  }
  .locationInputDiv{
    padding: 40px;
  }
}

  /****************************************************************************/
  /****************************************************************************/
  /***                     SELECTEUR MONTANT FACTURE                        ***/
  /****************************************************************************/
  /****************************************************************************/
  .wrapper-range{
    height: 80px;
    background: #fff;
    border-radius: 10px;
    padding: 40px 40px 20px 40px;
  }

  .field{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;
    flex-wrap:wrap;
    width:100%;
    margin:0;
  }
  .field .value{
    font-size: 18px;
    color: #008a83;
    font-weight: 600;
    width: 50px;
    display:block;
  }
  .field .value.left{
    text-align: left;
  }
  .field .value.right{
    text-align: right;
  }
  .field input {
    flex: 1 1 auto;
  }

  .sliderValue{
    position: relative;
    width: 100%;
        top:-40px;
  }
  .sliderValue span{
    position: absolute;
    width: 100%;
    font-weight: 500;
    color: #008a83;
    font-size:28px;
    text-align:center;
  }


  input[type="range"]{
    -webkit-appearance: none;
    width: calc(100% - 100px);
    height: 8px;
    outline: none !important;
    appearance:none;
    border:none;
    margin:0;
    border-radius:30px;
  }
  input[type="range"]::-moz-focus-outer {
      border: 0;
  }
  input[type="range"]:hover {
    outline:none;
  }


  input[type=range]::-webkit-slider-runnable-track {
    background-color: #ccc;
    border-radius:30px;
    border:none;
      height: 100%;
  }

  input[type=range]::-webkit-slider-thumb {
      -webkit-appearance: none;
      border: none;
      height: 24px;
      width: 24px;
      background: #008a83;
      cursor: pointer;
      border-radius:50%;
      border:4px solid #008a83;
      margin-top: -8px;
  }

  /* Moz */

  input[type="range"]::-moz-range-thumb {
    width: 18px;
    height: 18px;
    background: #008a83;
    cursor: pointer;
    border-radius:50%;
    border:4px solid #008a83;
    outline:none;
  }
  input[type="range"]::-moz-range-progress {
    background-color: #ccc;
      height: 100%;
    border-radius:30px;
    border:none;
  }
  input[type="range"]::-moz-range-track {
    background-color: #ccc;
    border-radius:30px;
    border:none;
      height: 100%;
  }

  /* IE*/

  input[type="range"]::-ms-fill-lower {
    background-color: #ccc;
      height: 100%;
    border-radius:30px;
    border:none;
  }
  input[type="range"]::-ms-fill-upper {
    background-color: #ccc;
    border-radius:30px;
    border:none;
      height: 100%;
  }








  /****************************************************************************/
  /****************************************************************************/
  /***                        SELECTEUR INCLINAISON                         ***/
  /****************************************************************************/
  /****************************************************************************/
    .inclinaison_wrapper{
      max-width: 100%;
      background: #FFF;
      border-radius: 10px;
      display:flex;
       flex-wrap: wrap;
  }
  .form__answer {
  box-sizing: border-box;
  font-size: 22px;
  text-align: center;
  align-self: center;
  /* flex:1; */
  margin-left: 15px;
margin-right: 15px;
height: 100%;
flex:auto;
width: calc(100% / 6 - 30px);
align-self: baseline;
}

@media screen and (max-width : 1223px) {
  .form__answer {
width: calc(100% / 3 - 30px);
}
}

@media screen and (max-width : 769px) {
  .form__answer {
width: calc(100% / 2 - 30px);
}
}
.inclinaison_wrapper label {
  padding: 50px 10px 50px 10px;
  box-sizing: border-box;
  display: block;
  height: 100%;
  width: 100%;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 10%;
  font-size:18px;
  box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.07);
-webkit-box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.07);
-moz-box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.07);
}

.inclinaison_wrapper .text_black{
  color: #000;
  margin-top: 20px;
}
.inclinaison_wrapper .text_green{
  color:#008a83;
  margin-top: 10px;
}

.inclinaison_wrapper input[type=radio] {
  opacity: 0;
  width: 0;
  height: 0;
  display:none;
}

.inclinaison_wrapper input[type=radio]:active ~ label {
  opacity: 1;
}

.inclinaison_wrapper input[type=radio]:checked ~ label {
  opacity: 1;
  color:#FFF !important;
  background: #008a83;
}
.inclinaison_wrapper input[type=radio]:checked ~ label span{
  color: #FFF;

}








.circle-container {
  position: relative;
  width: 400px;
  height: 18em;
  padding: .8em;
  border-radius: 50%;
  display: block;
  flex: 1;

}
.circle-container input[type=radio] {
  opacity: 0;
  width: 0;
  height: 0;
}


.circle-container label {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 4em;
  height: 4em;
  margin: -2em;

  border:3px solid transparent;
}
.circle-container div{
  display: flex;

  position: absolute;
  top: 50%;
  left: 50%;
  width: 6em;
  height: 4em;
  margin: -2em;

}


.circle-container input[type=radio]:checked ~ label {
  color:#008a83;
}
label.deg1 {
  height: 5.5em;
    transform:  translateY(-6.5em);
  background-size: 100%;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 111.55 218.54'><title>Fichier 5</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path style='fill:none;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;' class='cls-1' d='M108.72,148a94,94,0,0,0,.19-12.84C107.34,83.9,74.68,27.9,54.8,3.87,34.63,27.08,2.35,84.09,2.5,136.24a50,50,0,0,0,.29,6.4A53.22,53.22,0,0,0,108.72,148Z'/><path style='fill:%23fff;' class='cls-2' d='M54.75,216c1.64-8.23,32.3-49.15,35.41-64.87,5.18-26.1-25.32-44.93-35.54-57-10.21,11.37-39.94,29.07-35.44,54.52,2.89,16.35,33.9,59,35.57,67.33'/><path style='fill:none;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round;'  class='cls-3' d='M54.75,216c1.64-8.23,32.3-49.15,35.41-64.87,5.18-26.1-25.32-44.93-35.54-57-10.21,11.37-39.94,29.07-35.44,54.52,2.89,16.35,33.9,59,35.57,67.33'/></g></g></svg>");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.circle-container div.deg1 {
transform: translate(-1em, -5em);
}
.circle-container div.deg1 span{
  align-self: end;
  text-align: center;
  display: block;
  width: 100%;

}
.circle-container input[type=radio]:checked ~ label.deg1 {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 111.55 218.54'><title>Fichier 5</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path style='fill:%23008a83;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;' class='cls-1' d='M108.72,148a94,94,0,0,0,.19-12.84C107.34,83.9,74.68,27.9,54.8,3.87,34.63,27.08,2.35,84.09,2.5,136.24a50,50,0,0,0,.29,6.4A53.22,53.22,0,0,0,108.72,148Z'/><path style='fill:%23fff;' class='cls-2' d='M54.75,216c1.64-8.23,32.3-49.15,35.41-64.87,5.18-26.1-25.32-44.93-35.54-57-10.21,11.37-39.94,29.07-35.44,54.52,2.89,16.35,33.9,59,35.57,67.33'/><path style='fill:%23ffcf00;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round;'  class='cls-3' d='M54.75,216c1.64-8.23,32.3-49.15,35.41-64.87,5.18-26.1-25.32-44.93-35.54-57-10.21,11.37-39.94,29.07-35.44,54.52,2.89,16.35,33.9,59,35.57,67.33'/></g></g></svg>");
  background-repeat: no-repeat;
  }

label.deg2 {
  transform: translateX(4em) translateY(-4em);
  background-size: 100%;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 155.34 156.11'><title>Fichier 2</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path style='fill:none;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;' class='cls-1' d='M88.8,142.72A92.49,92.49,0,0,0,98,133.77c35.12-37.33,51.62-100,54.56-131.07C121.89,4.85,58.75,22.33,22,59.32a48.94,48.94,0,0,0-4.31,4.73A53.22,53.22,0,0,0,88.8,142.72Z'/><path style='fill:%23fff;' class='cls-2' d='M2.5,152.69c7-4.65,57.59-11.91,70.91-20.82,22.12-14.8,13.87-49.68,15.16-65.43-15.26.82-48.8-7.69-63.61,13.49C15.44,93.54,7.22,145.62,2.5,152.69'/><path style='fill:none;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round'  class='cls-3' d='M2.5,152.69c7-4.65,57.59-11.91,70.91-20.82,22.12-14.8,13.87-49.68,15.16-65.43-15.26.82-48.8-7.69-63.61,13.49C15.44,93.54,7.22,145.62,2.5,152.69'/></g></g></svg>");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.circle-container div.deg2 {
  transform: translate(4em,-4em);
}
.circle-container div.deg2 span{
  align-self: end;
  text-align: left;
  display: block;
  width: 100%;
}
.circle-container input[type=radio]:checked ~ label.deg2 {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 155.34 156.11'><title>Fichier 2</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path style='fill:%23008a83;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;' class='cls-1' d='M88.8,142.72A92.49,92.49,0,0,0,98,133.77c35.12-37.33,51.62-100,54.56-131.07C121.89,4.85,58.75,22.33,22,59.32a48.94,48.94,0,0,0-4.31,4.73A53.22,53.22,0,0,0,88.8,142.72Z'/><path style='fill:%23fff;' class='cls-2' d='M2.5,152.69c7-4.65,57.59-11.91,70.91-20.82,22.12-14.8,13.87-49.68,15.16-65.43-15.26.82-48.8-7.69-63.61,13.49C15.44,93.54,7.22,145.62,2.5,152.69'/><path style='fill:%23ffcf00;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round'  class='cls-3' d='M2.5,152.69c7-4.65,57.59-11.91,70.91-20.82,22.12-14.8,13.87-49.68,15.16-65.43-15.26.82-48.8-7.69-63.61,13.49C15.44,93.54,7.22,145.62,2.5,152.69'/></g></g></svg>");
  background-repeat: no-repeat;
  }


label.deg3 {
  transform: translate(5em);
  background-size: 100%;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 218.54 111.55'><title>Fichier 7</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path style='fill:none;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;' class='cls-1' d='M70.57,108.72a94,94,0,0,0,12.84.19c51.23-1.57,107.24-34.23,131.27-54.11C191.46,34.63,134.46,2.35,82.3,2.5a49.93,49.93,0,0,0-6.39.29,53.22,53.22,0,0,0-5.34,105.93Z'/><path style='fill:%23fff;' class='cls-2' d='M2.5,54.75c8.23,1.64,49.15,32.3,64.87,35.41,26.1,5.18,44.93-25.32,57-35.54C113,44.41,95.28,14.68,69.84,19.18c-16.36,2.89-59,33.9-67.34,35.57'/><path style='fill:none;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round;' class='cls-3' d='M2.5,54.75c8.23,1.64,49.15,32.3,64.87,35.41,26.1,5.18,44.93-25.32,57-35.54C113,44.41,95.28,14.68,69.84,19.18c-16.36,2.89-59,33.9-67.34,35.57'/></g></g></svg>");
  width:5.5em;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.circle-container div.deg3 {
  transform: translate(5em);
}
.circle-container div.deg3 span{
  align-self: center;
  text-align: left;
  display: block;
  width: 100%;
}

.circle-container input[type=radio]:checked ~ label.deg3 {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 218.54 111.55'><title>Fichier 7</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path style='fill:%23008a83;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;' class='cls-1' d='M70.57,108.72a94,94,0,0,0,12.84.19c51.23-1.57,107.24-34.23,131.27-54.11C191.46,34.63,134.46,2.35,82.3,2.5a49.93,49.93,0,0,0-6.39.29,53.22,53.22,0,0,0-5.34,105.93Z'/><path style='fill:%23fff;' class='cls-2' d='M2.5,54.75c8.23,1.64,49.15,32.3,64.87,35.41,26.1,5.18,44.93-25.32,57-35.54C113,44.41,95.28,14.68,69.84,19.18c-16.36,2.89-59,33.9-67.34,35.57'/><path style='fill:%23ffcf00;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round;' class='cls-3' d='M2.5,54.75c8.23,1.64,49.15,32.3,64.87,35.41,26.1,5.18,44.93-25.32,57-35.54C113,44.41,95.28,14.68,69.84,19.18c-16.36,2.89-59,33.9-67.34,35.57'/></g></g></svg>");

  }



label.deg4 {
  transform: translateX(4em) translateY(4em);
  background-size: 100%;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 156.11 155.34'><title>Fichier 6</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path  style='fill:none;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;'  class='cls-1' d='M13.39,88.8A91.24,91.24,0,0,0,22.33,98c37.34,35.12,100,51.62,131.08,54.56C151.26,121.89,133.77,58.75,96.79,22a50.53,50.53,0,0,0-4.73-4.32A53.22,53.22,0,0,0,13.39,88.8Z'/><path style='fill:%23fff;'  class='cls-2' d='M3.41,2.5c4.66,7,11.92,57.59,20.83,70.91C39,95.53,73.92,87.28,89.67,88.57,88.85,73.31,97.36,39.77,76.18,25,62.57,15.44,10.49,7.22,3.41,2.5'/><path  style='fill:none;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round;' class='cls-3' d='M3.41,2.5c4.66,7,11.92,57.59,20.83,70.91C39,95.53,73.92,87.28,89.67,88.57,88.85,73.31,97.36,39.77,76.18,25,62.57,15.44,10.49,7.22,3.41,2.5'/></g></g></svg>");
  background-repeat: no-repeat;
background-size: contain;
background-position: center;
}
.circle-container div.deg4 {
  transform: translate(4em,4em);
}
.circle-container div.deg4 span{
  align-self: baseline;
  text-align: left;
  display: block;
  width: 100%;
}
.circle-container input[type=radio]:checked ~ label.deg4 {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 156.11 155.34'><title>Fichier 6</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path  style='fill:%23008a83;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;'  class='cls-1' d='M13.39,88.8A91.24,91.24,0,0,0,22.33,98c37.34,35.12,100,51.62,131.08,54.56C151.26,121.89,133.77,58.75,96.79,22a50.53,50.53,0,0,0-4.73-4.32A53.22,53.22,0,0,0,13.39,88.8Z'/><path style='fill:%23fff;'  class='cls-2' d='M3.41,2.5c4.66,7,11.92,57.59,20.83,70.91C39,95.53,73.92,87.28,89.67,88.57,88.85,73.31,97.36,39.77,76.18,25,62.57,15.44,10.49,7.22,3.41,2.5'/><path  style='fill:%23ffcf00;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round;' class='cls-3' d='M3.41,2.5c4.66,7,11.92,57.59,20.83,70.91C39,95.53,73.92,87.28,89.67,88.57,88.85,73.31,97.36,39.77,76.18,25,62.57,15.44,10.49,7.22,3.41,2.5'/></g></g></svg>");

  }


label.deg5 {
  height: 5.5em;
  transform:  translateY(5em);
  background-size: 100%;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 106.78 214.31'><title>Fichier 6</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path style='fill:none;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;' class='cls-1' d='M2.72,72.67A86.22,86.22,0,0,0,2.54,85C4,134,35.3,187.61,54.32,210.61c19.31-22.22,50.21-76.79,50.07-126.71a48.09,48.09,0,0,0-.28-6.12A50.94,50.94,0,0,0,2.72,72.67Z'/><path style='fill:%23fff;' class='cls-2' d='M56.7,2.5c-1.64,8.23-32.3,49.15-35.42,64.87-5.18,26.1,25.32,44.93,35.55,57C67,113,96.77,95.28,92.27,69.84c-2.89-16.36-33.9-59-35.57-67.34'/><path  style='fill:none;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round;' class='cls-3' d='M56.7,2.5c-1.64,8.23-32.3,49.15-35.42,64.87-5.18,26.1,25.32,44.93,35.55,57C67,113,96.77,95.28,92.27,69.84c-2.89-16.36-33.9-59-35.57-67.34'/></g></g></svg>");
  background-repeat: no-repeat;
  background-size:contain;
  background-position: center;
}
.circle-container div.deg5 {
transform: translate(-1em, 5em);
}
.circle-container div.deg5 span{
  align-self: baseline;
  text-align: center;
  display: block;
  width: 100%;
}


.circle-container input[type=radio]:checked ~ label.deg5 {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 106.78 214.31'><title>Fichier 6</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path style='fill:%23008a83;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;' class='cls-1' d='M2.72,72.67A86.22,86.22,0,0,0,2.54,85C4,134,35.3,187.61,54.32,210.61c19.31-22.22,50.21-76.79,50.07-126.71a48.09,48.09,0,0,0-.28-6.12A50.94,50.94,0,0,0,2.72,72.67Z'/><path style='fill:%23fff;' class='cls-2' d='M56.7,2.5c-1.64,8.23-32.3,49.15-35.42,64.87-5.18,26.1,25.32,44.93,35.55,57C67,113,96.77,95.28,92.27,69.84c-2.89-16.36-33.9-59-35.57-67.34'/><path  style='fill:%23ffcf00;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round;' class='cls-3' d='M56.7,2.5c-1.64,8.23-32.3,49.15-35.42,64.87-5.18,26.1,25.32,44.93,35.55,57C67,113,96.77,95.28,92.27,69.84c-2.89-16.36-33.9-59-35.57-67.34'/></g></g></svg>");

  }

label.deg6 {
  transform:  translateX(-4em) translateY(4em);
  background-size: 100%;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 155.34 156.11'><title>Fichier 8</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path style='fill:none;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;' class='cls-1' d='M66.54,13.39a91.24,91.24,0,0,0-9.21,8.94C22.21,59.67,5.7,122.36,2.77,153.41c30.68-2.15,93.81-19.64,130.58-56.62a50.53,50.53,0,0,0,4.32-4.73A53.22,53.22,0,0,0,66.54,13.39Z'/><path style='fill:%23fff;' class='cls-2' d='M152.84,3.41c-7,4.66-57.6,11.92-70.92,20.83C59.8,39,68.05,73.92,66.77,89.67c15.26-.82,48.79,7.69,63.61-13.49,9.52-13.61,17.73-65.69,22.46-72.77'/><path style='fill:none;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round;' class='cls-3' d='M152.84,3.41c-7,4.66-57.6,11.92-70.92,20.83C59.8,39,68.05,73.92,66.77,89.67c15.26-.82,48.79,7.69,63.61-13.49,9.52-13.61,17.73-65.69,22.46-72.77'/></g></g></svg>");
  background-repeat: no-repeat;
  background-size:contain;
  background-position: center;
}
.circle-container div.deg6 {
  transform:  translate(-6em, 4em);
}
.circle-container div.deg6 span{
  align-self: baseline;
  text-align: right;
  display: block;
  width: 100%;
}
.circle-container input[type=radio]:checked ~ label.deg6 {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 155.34 156.11'><title>Fichier 8</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path style='fill:%23008a83;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;' class='cls-1' d='M66.54,13.39a91.24,91.24,0,0,0-9.21,8.94C22.21,59.67,5.7,122.36,2.77,153.41c30.68-2.15,93.81-19.64,130.58-56.62a50.53,50.53,0,0,0,4.32-4.73A53.22,53.22,0,0,0,66.54,13.39Z'/><path style='fill:%23fff;' class='cls-2' d='M152.84,3.41c-7,4.66-57.6,11.92-70.92,20.83C59.8,39,68.05,73.92,66.77,89.67c15.26-.82,48.79,7.69,63.61-13.49,9.52-13.61,17.73-65.69,22.46-72.77'/><path style='fill:%23ffcf00;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round;' class='cls-3' d='M152.84,3.41c-7,4.66-57.6,11.92-70.92,20.83C59.8,39,68.05,73.92,66.77,89.67c15.26-.82,48.79,7.69,63.61-13.49,9.52-13.61,17.73-65.69,22.46-72.77'/></g></g></svg>");

  }

label.deg7 {
  transform: translate(-6.5em);
  background-size: 100%;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 218.54 111.55'><title>Fichier 7</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path style='fill:none;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;' class='cls-1' d='M148,2.84a90.87,90.87,0,0,0-12.84-.19C83.9,4.22,27.9,36.88,3.87,56.75c23.21,20.18,80.22,52.46,132.37,52.3a50.53,50.53,0,0,0,6.4-.28A53.22,53.22,0,0,0,148,2.84Z'/><path style='fill:%23fff;' class='cls-2' d='M216,56.81c-8.23-1.65-49.15-32.3-64.87-35.42-26.1-5.18-44.93,25.32-57,35.55,11.37,10.21,29.07,39.94,54.52,35.44,16.35-2.9,59-33.91,67.33-35.57'/><path style='fill:none;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round;' class='cls-3' d='M216,56.81c-8.23-1.65-49.15-32.3-64.87-35.42-26.1-5.18-44.93,25.32-57,35.55,11.37,10.21,29.07,39.94,54.52,35.44,16.35-2.9,59-33.91,67.33-35.57'/></g></g></svg>");
  background-repeat: no-repeat;
  background-size:contain;
  background-position: center;
  width: 5.5em;

}
.circle-container div.deg7 {
  transform: translate(-7em) ;
}

.circle-container div.deg7 span{
  align-self: center;
  text-align: right;
  display: block;
  width: 100%;
}

.circle-container input[type=radio]:checked ~ label.deg7 {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 218.54 111.55'><title>Fichier 7</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path style='fill:%23008a83;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;' class='cls-1' d='M148,2.84a90.87,90.87,0,0,0-12.84-.19C83.9,4.22,27.9,36.88,3.87,56.75c23.21,20.18,80.22,52.46,132.37,52.3a50.53,50.53,0,0,0,6.4-.28A53.22,53.22,0,0,0,148,2.84Z'/><path style='fill:%23fff;' class='cls-2' d='M216,56.81c-8.23-1.65-49.15-32.3-64.87-35.42-26.1-5.18-44.93,25.32-57,35.55,11.37,10.21,29.07,39.94,54.52,35.44,16.35-2.9,59-33.91,67.33-35.57'/><path style='fill:%23ffcf00;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round;' class='cls-3' d='M216,56.81c-8.23-1.65-49.15-32.3-64.87-35.42-26.1-5.18-44.93,25.32-57,35.55,11.37,10.21,29.07,39.94,54.52,35.44,16.35-2.9,59-33.91,67.33-35.57'/></g></g></svg>");

  }

label.deg8 {
  transform:  translateX(-4em) translateY(-4em);
  background-size: 100%;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 156.11 155.34'><title>Fichier 9</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path style='fill:none;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;' class='cls-1' d='M142.72,66.54a91.42,91.42,0,0,0-8.95-9.21C96.44,22.21,33.75,5.7,2.7,2.77,4.85,33.45,22.33,96.58,59.32,133.35a48.07,48.07,0,0,0,4.73,4.32,53.22,53.22,0,0,0,78.67-71.13Z'/><path style='fill:%23fff;' class='cls-2' d='M152.69,152.84c-4.65-7-11.91-57.6-20.82-70.92C117.07,59.8,82.19,68.05,66.44,66.77c.82,15.26-7.69,48.79,13.49,63.61,13.61,9.52,65.69,17.73,72.76,22.46'/><path style='fill:none;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round;' class='cls-3' d='M152.69,152.84c-4.65-7-11.91-57.6-20.82-70.92C117.07,59.8,82.19,68.05,66.44,66.77c.82,15.26-7.69,48.79,13.49,63.61,13.61,9.52,65.69,17.73,72.76,22.46'/></g></g></svg>");
  background-repeat: no-repeat;
  background-size:contain;
  background-position: center;
}
.circle-container div.deg8 {
  transform: translate(-7em, -4em);
  width:7em;
}

.circle-container div.deg8 span{
  align-self: end;
  text-align: right;
  display: block;
  width: 100%;
}
.circle-container input[type=radio]:checked ~ label.deg8 {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 156.11 155.34'><title>Fichier 9</title><g id='Calque_2' data-name='Calque 2'><g id='Calque_1-2' data-name='Calque 1'><path style='fill:%23008a83;stroke-width:5px;stroke:%23008a83;stroke-miterlimit:10;' class='cls-1' d='M142.72,66.54a91.42,91.42,0,0,0-8.95-9.21C96.44,22.21,33.75,5.7,2.7,2.77,4.85,33.45,22.33,96.58,59.32,133.35a48.07,48.07,0,0,0,4.73,4.32,53.22,53.22,0,0,0,78.67-71.13Z'/><path style='fill:%23fff;' class='cls-2' d='M152.69,152.84c-4.65-7-11.91-57.6-20.82-70.92C117.07,59.8,82.19,68.05,66.44,66.77c.82,15.26-7.69,48.79,13.49,63.61,13.61,9.52,65.69,17.73,72.76,22.46'/><path style='fill:%23ffcf00;stroke-width:5px;stroke:%23ffcf00;stroke-linecap:round;stroke-linejoin:round;' class='cls-3' d='M152.69,152.84c-4.65-7-11.91-57.6-20.82-70.92C117.07,59.8,82.19,68.05,66.44,66.77c.82,15.26-7.69,48.79,13.49,63.61,13.61,9.52,65.69,17.73,72.76,22.46'/></g></g></svg>");

  }


  .circle-container  label:hover > div {
    display:flex !important;
  }


 @media only screen and (max-width : 768px){
   .sunPositionSideIndicator{
     display:none;
   }
   .circle-container {
     width:100%;
   }
 }




.recommandations {
  display: flex;
  padding: 40px;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  background-color: #f1f4f8;
  border-radius: 25px 25px 0px 0px;
}
.recommandations .leftContainer{
  width: 60%;
}

.recommandations .rightContainer{
  width: 40%;
}

@media screen and (max-width: 768px){
  .recommandations .leftContainer,
  .recommandations .rightContainer{
    width:100%;
    text-align:center;
}
}
.panelsHeader {
  color: #008a83;
  display: flex;
  text-align: center;
  align-items: center;
  font-weight: bold;
  flex-direction: column;
  justify-content: center;
}
.panels-heading{
  font-size:20px;
}
.panelsHeader > .pvSize{
  font-size: 30px;
}

.panneauxIcons {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap:wrap;
}

.panneauxIcons svg{
  margin:4px;
  width:20px;
}

#orientationZone{
  box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.07);
  -webkit-box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.07);
  -moz-box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.07);
padding:20px;
border-radius:20px;
}


#calculateurSunethic  button:not(.vue-number-input__button):not(.btn-close){
  background : #ffcf00;
  border-radius:15px;
  color:#000;
  text-transform: uppercase;
  display:inline-block;
  border:2px solid #FFCF00;
  margin-top: 30px;
  margin-left: 10px;
  margin-right:10px;
}
#calculateurSunethic button:not(.vue-number-input__button):not(.btn-close):hover{
    background : #FFF;
}

#calculateurSunethic .entryPointSunEthic button:not(.vue-number-input__button):not(.btn-close){
  display:block;
  margin-left:auto;
  margin-right: auto;
}
#gotokitFooter{
  display:inline-block;  border-radius: 30px !important;margin-left:auto;margin-right:auto;
}
#callCalendly{
  margin: 10px;
  line-height: 1rem;
  background: #ffcf00;
  color: #000;
  text-transform: uppercase;
  border: 2px solid #ffcf00;
  margin-top: 30px;
  border-radius: 30px !important;
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 14px;
}
#callCalendly:hover{
      background : #FFF;
        color:#000 !important;
}

.cls-1,.cls-3{fill:none;stroke-width:5px;}.cls-1{stroke:#008a83;stroke-miterlimit:10;}.cls-2{fill:#fff;}.cls-3{stroke:#ffcf00;stroke-linecap:round;stroke-linejoin:round;}
.st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}
.st1{clip-path:url(#SVGID_5_);fill:url(#SVGID_6_);}
.st2{clip-path:url(#SVGID_5_);}

.st0_P{clip-path:url(#SVGID_2_P);fill:url(#SVGID_3_P);}

#calculateurSunethic .sectionTitle{
  font-size:30px;text-align:center;margin-bottom: 50px;
}

#calculateurSunethic .sectionContainer{
  margin-top:75px;
  margin-bottom:75px;
}
#calculateurSunethic .sectionContainer:first-of-type{
  margin-top:0px;
}


#calculateurSunethic #errorEstimation{
  width:100%;
  padding:20px;
  margin-top:50px;
  margin-bottom: 50px;
  background:#e67878;
  color:#fff;
}
#calculateurSunethic #errorSendEtudeByMail{
  width:100%;
  padding:20px;
  margin-top:50px;
  margin-bottom: 50px;
  background:#e67878;
  color:#fff;
}
#calculateurSunethic #etudeSend{
  width:100%;
  padding:20px;
  margin-top:50px;
  margin-bottom: 50px;
  background:#008a83;
  color:#fff;
}

#calculateurSunethic .resultDataContainer{
  border: 3px solid #f1f4f8;
  padding: 20px;

}
≈
#calculateurSunethic .dataItem{
  width: calc(50% - 20px);
  margin: 10px;
}

#calculateurSunethic .oneLine .dataItem{
  width: calc(25% - 20px);
  margin: 10px;
}

#calculateurSunethic .resultEcoDatas,
#calculateurSunethic .resultProductDatas{
  margin-top: 50px;
padding-top: 20px;
}

#calculateurSunethic .text-justify{
  text-align: justify
}

.vue-apexcharts{
  min-width: 350px;
flex: 1 1 0%;
width: 100%;
min-height: 253.509px;
}
.btn-simulateur{
      border-radius: 30px !important;
  padding: 10px 40px;
  -webkit-border-radius : 30px !important;
  margin: 10px;
    margin-top: 10px;
    margin-right: 10px;
    margin-left: 10px;
  line-height: 1rem;
  background: #ffcf00;
  color: #000;
  text-transform: uppercase;
  border: 2px solid #ffcf00;
  margin-top: 30px;
  border-radius: 30px !important;
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 14px;
}
.btn-simulateur:hover{
        background : #FFF;
          color:#000 !important;
}
:root {
  --toggle-width: 4rem;
  --toggle-height: 1.2rem;
  --toggle-font-size: 0.8rem;
  --toggle-bg-on: #008a83;
  --toggle-border-on: #008a83;

}

.recoDesc{
  max-width: 75%;
  margin-bottom: 20px;
}
.resultProductDatas .dataItem strong,
.resultEcoDatas .dataItem strong{
  font-size:1.5em;
}

.dataItem.dataImportant strong{
  color: #008a83;
}
@media screen and (max-width: 768px){
  .recoDesc{
    max-width:100%;
  }
  #calculateurSunethic .dataItem,
  #calculateurSunethic .oneLine .dataItem{
    width: calc(100% - 20px);
    margin: 10px;
  }
  .rightContainer{
    margin-top:20px;
  }
}
@media only screen and (min-width : 768px) and (max-width : 1024px) {
  #calculateurSunethic .oneLine .dataItem{
    width: calc(50% - 20px);
    margin: 10px;
  }
}

.vue-number-input{
  margin-top:20px;
}

.reassurance{
  display: flex;
  margin-bottom: 2rem;
  padding: 10px;
  align-content: center;
  align-items: center;
  background: #FFF;
  box-shadow: 0 0 7px 1px rgba(0,0,0,.07);
  -webkit-box-shadow: 0 0 7px 1px rgba(0,0,0,.07);
}
.reassurance img{
  border-radius:50%;
  width: 150px !important;
margin-bottom: 0 !important;
}
.reassurance_profile{
  margin-right: 20px;
}
.reassurance_content{
  margin-bottom: 5px;
  font-size: 15px !important;

}
.reassurance_info{
  padding-bottom: 0;
padding-top: 10px;
}

.reassurance_content ul{
  margin-bottom: 0;
}
@media only screen and (max-width : 1024px) {
   .reassurance{
     display: block;
     width:100%;
  }
  .reassurance_profile{
    text-align: center;
  }
 }
 @media only screen and (max-width : 768px){
   .reassurance img{
     border-radius:50%;
     width: 100px !important;
  }
 }
.tooltip {
  position: relative;
  display: inline;
  border-radius: 50%;
  border: 1px solid #ccc;
  padding: 5px 10px;
  color: #CCC;
  font-size: 15px;
  font-family: "Poppins";
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 400px;
  background-color: #FFF;
  color: #000;
  text-align: justify;
  padding: 10px;
  border-radius: 6px;
  position: absolute;
  z-index: 50;
  -webkit-box-shadow: 0px 0px 11px 0px rgba(0,0,0,0.07);
  box-shadow: 0px 0px 11px 0px rgba(0,0,0,0.07);
  top: calc(100% + 10px);
  left: calc(0% - 200px);
  line-height: 1.2rem;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
<style src="@vueform/toggle/themes/default.css"></style>
